import { render, staticRenderFns } from "./blackdeviceip.vue?vue&type=template&id=2505ba2a&scoped=true"
import script from "./blackdeviceip.vue?vue&type=script&lang=js"
export * from "./blackdeviceip.vue?vue&type=script&lang=js"
import style0 from "./blackdeviceip.vue?vue&type=style&index=0&id=2505ba2a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2505ba2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2505ba2a')) {
      api.createRecord('2505ba2a', component.options)
    } else {
      api.reload('2505ba2a', component.options)
    }
    module.hot.accept("./blackdeviceip.vue?vue&type=template&id=2505ba2a&scoped=true", function () {
      api.rerender('2505ba2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ad/blackdeviceip.vue"
export default component.exports